import moment from 'moment-timezone';
import numeral from 'numeral';
import i18next from 'i18next';
import LocalStorageService from 'web-app/services/local-storage';
import * as InContextTranslation from 'web-app/services/in-context-translation';
import SHARED_ENVIRONMENT_CONFIG from 'web-app/shared/environment';
const getOverriddenLocale = () => {
    return LocalStorageService.getFromLocalStorage('overriddenLocale');
};
const determineLocale = (defaultLocale) => {
    // If we're in translation mode, we always want
    // to use the esparanto language
    if (InContextTranslation.isTranslating()) {
        return 'eo_UY';
    }
    /*
    When we're in development mode, the selected language is 'en_US' and we're in the web-app,
    use the 'base.json' translation file.
    Added the local storage stuff so we can easily override this behavior.
    */
    const dontShowBaseTranslations = Boolean(LocalStorageService.getFromLocalStorage('dontShowBaseTranslations'));
    const i18nextLocale = SHARED_ENVIRONMENT_CONFIG.IS_DEVELOPMENT && !dontShowBaseTranslations && defaultLocale === 'en_US'
        ? 'en-JM'
        : defaultLocale;
    return i18nextLocale;
};
/**
 * Necessary as moment defines Nowegian as 'nb' (not 'no').
 *
 * If moment cannot properly resolve the provided locale,
 * it defaults to the locale last defined in app/setup/moment-setup.js.
 */
const resolveMomentLocale = (ourLocale) => {
    if (ourLocale.startsWith('no')) {
        return 'nb';
    }
    else {
        return ourLocale;
    }
};
/** The i18next language `setLocale` switches to for an account's locale. */
export const getI18nextLanguage = (locale) => (getOverriddenLocale() || determineLocale(locale)).replace('_', '-');
export const setLocale = (locale) => {
    return new Promise((resolve, reject) => {
        const possibleOverriddenLocale = getOverriddenLocale();
        const chosenLocale = possibleOverriddenLocale || locale;
        moment.locale(resolveMomentLocale(chosenLocale));
        numeral.locale(chosenLocale);
        i18next.changeLanguage(getI18nextLanguage(locale), err => {
            if (err) {
                reject(err);
            }
            resolve(chosenLocale);
        });
        LocalStorageService.saveToLocalStorage('locale', chosenLocale);
    });
};
const hasSAsLastCharacter = (name) => name !== null && name !== undefined && name[name.length - 1] === 's';
const getUKOwners = (name) => {
    const hasS = hasSAsLastCharacter(name);
    if (hasS) {
        return `${name}'`;
    }
    return `${name}'s`;
};
const getDKOwners = (name) => {
    const hasS = hasSAsLastCharacter(name);
    if (hasS) {
        return `${name}'`;
    }
    return `${name}s`;
};
export const getOwnersFormName = (nameObj) => {
    switch (i18next.language) {
        case 'da-DK':
            return getDKOwners(nameObj.fullName);
        case 'en-GB':
        case 'en-US':
            return getUKOwners(nameObj.fullName);
        default:
            return nameObj.fullName;
    }
};
/**
 * @deprecated Moved to `@famly/vet_ts-utils_languages`. Import from there instead.
 */
export { languageOptions } from '@famly/vet_ts-utils_languages';
